import { Skeleton as MuiSkeleton, SkeletonProps as MuiSkeletonProps } from '@material-ui/lab';
import { Theme, css } from '@emotion/react';
import React from 'react';

const skeletonBlock = ({ colors }: Theme) => css`
  background-color: ${colors.borderDefault};
  &:after {
    background: linear-gradient(90deg, transparent, ${colors.bgLight}, transparent);
  }
`;

const skeletonBlockRounded = ({ borderRadius }: Theme) => css`
  border-radius: ${borderRadius[100]};
`;

type SkeletonProps = MuiSkeletonProps & { rounded?: boolean };

const Skeleton: React.FunctionComponent<SkeletonProps> = ({
  className,
  animation = 'wave',
  rounded,
  ...props
}) => {
  return (
    <MuiSkeleton
      css={[skeletonBlock, rounded && skeletonBlockRounded]}
      animation={animation}
      {...props}
    />
  );
};

export default Skeleton;
